__turbopack_context__.v({
  "article": "tweet-container-module__CmFQMq__article",
  "root": "tweet-container-module__CmFQMq__root",
});
